import { makeStyles, Typography } from "@material-ui/core";


const FooterBar = () => {

    const useStyles = makeStyles(theme => ({
        style: {
            backgroundColor: theme.palette.primary.main,
            borderTop: "1px solid #E7E7E7",
            textAlign: "center",
            padding: "10px",
            position: "fixed",
            left: "0",
            bottom: "0",
            width: "100%",
            display: 'flex',
            flexWrap: 'wrap'
        },
        links: {
            transition: '0.6s',
            "&:hover": {
                color: theme.palette.primary.light,
                cursor: 'pointer'
            }
        },
        a: {
            color: 'inherit',
            textDecoration: 'none',
            textAlign: 'center'
        }
    }));

    const classes = useStyles();

    return (
        <div className={classes.style}>
            <div style={{ margin: '0px auto', alignItems: 'center', display: 'flex', flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'center' }}>
                <div style={{ margin: '0px 10px', marginBottom: 8, color: 'white' }}><a className={classes.a} href="https://www.sinclairgore.co.uk/privacy-policy/"><Typography className={classes.links} style={{ fontSize: 16, fontWeight: 'bold' }}>Privacy and Cookie Policy</Typography></a></div>
                <div style={{ margin: '0px 10px', marginBottom: 8, color: 'white' }}><a className={classes.a} href="https://www.sinclairgore.co.uk/terms-conditions/"><Typography className={classes.links} style={{ fontSize: 16, fontWeight: 'bold', textAlign: 'center' }}>Terms and Conditions</Typography></a></div>
            </div>
            <div className={classes.break}></div>
            <div style={{ margin: '0px auto', color: 'white', marginBottom: 8, width: '90%' }}><Typography style={{ fontSize: 14 }}>Copyright © 2023. Sinclair Gore Ltd. Registered in England & Wales No. 9341816</Typography></div>
        </div>
    );
}

export default FooterBar;